import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isTrashieContainerPublicCenteredPath } from '../../utils/routes';
import { setDocumentTitle } from '../../utils/utils';

import './TrashieContainerPublicCentered.scss';

const TrashieContainerPublicCentered = ({
  children,
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    setDocumentTitle();
  }, [pathname]);

  if (!isTrashieContainerPublicCenteredPath(pathname)) {
    return children;
  }

  return (
    <div className="TrashieContainerPublicCentered">
      <div className="TrashieContainerPublicCentered__content">
        {children}
      </div>
    </div>
  );
};

export default TrashieContainerPublicCentered;
